import { createSelector } from '@reduxjs/toolkit';

import { getModelConceptClassValue } from 'src/containers/ProjectDiagram/utils/modelConceptClass/createModelConceptClass';
import { projectClassRelationshipsSelector } from 'src/selectors/projectClassRelationships';
import { projectMappingSelector } from 'src/selectors/projectMapping';
import { ReduxState } from 'src/store/types';

export const projectMappingRelationshipsSelector = (
  projectId: string,
  mappingId: string | undefined
) =>
  createSelector(
    projectMappingSelector(projectId, mappingId),
    (state: ReduxState) => state,
    (mapping, state) => {
      if (!mapping || !mapping.to) {
        return {};
      }

      const classIri = getModelConceptClassValue(mapping.to);
      return projectClassRelationshipsSelector(projectId, classIri)(state);
    }
  );
